import { 
    DeleteInvoiceRecapLineApiParameter,
    deleteInvoiceRecapLineWithResult as deleteInvoiceLineApi 
} from "@NA/Services/ADIInvoiceService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnSuccess, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<
    {
        invoiceNumber: string;
    } & HasOnSuccess, DeleteInvoiceRecapLineApiParameter
>;

export const DispatchBeginDeleteInvoicePaymentRecap: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginDeleteInvoicePaymentRecap",
        invoiceNumber: props.parameter.invoiceNumber,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        invoiceNumber: props.parameter.invoiceNumber,
    };
};

export const DeleteInvoicePaymentRecapLine: HandlerType = async props => {
    await deleteInvoiceLineApi(props.apiParameter);
};

export const CompleteDeleteInvoicePaymentRecap: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch({
            type: "Custom/CompleteDeleteInvoicePaymentRecap",
            invoiceNumber: props.parameter.invoiceNumber,
        });
    }
};

export const chain = [DispatchBeginDeleteInvoicePaymentRecap, PopulateApiParameter, DeleteInvoicePaymentRecapLine, CompleteDeleteInvoicePaymentRecap];

const adiDeleteInvoicePaymentRecap = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        invoiceNumber: "",
    },
    "ADIDeleteInvoicePaymentRecap",
);
export default adiDeleteInvoicePaymentRecap;
